import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

interface FormErrorBannerProps {
  errors: string[];
  className?: string;
}

export const FormErrorBanner: React.FC<FormErrorBannerProps> = ({ errors, className }) => {
  const { t } = useTranslation();

  if (errors.length === 0) {
    return null;
  }

  return (
    <div
      role="alert"
      className={cn(
        'rounded-md border border-destructive/20 bg-destructive/10 px-4 py-3 text-sm text-destructive',
        className,
      )}
    >
      <ul className="list-disc space-y-1 pl-5">
        {errors.map((error, index) => (
          <li key={`${error}-${index}`}>{t(error)}</li>
        ))}
      </ul>
    </div>
  );
};
